import { FloatingNode, useFloatingParentNodeId, FloatingTree } from '@floating-ui/react';
import React__default from 'react';
import { DropdownContext } from './dropdown_context.js';
import { useDropdown } from './use_dropdown.js';

const DropdownInner = ({ children, id, align = 'start', open, onToggle, anchorRef, kind = 'neutral', size = 'medium', disabled = false, className, }) => {
    const state = useDropdown({ open, onToggle, id, align, anchorRef, kind, size, disabled, className });
    return (React__default.createElement(DropdownContext.Provider, { value: state },
        React__default.createElement(FloatingNode, { id: state.nodeId }, children)));
};
/**
 * A dropdown menu displays a list of possible actions.
 */
const Dropdown = (props) => {
    const parentId = useFloatingParentNodeId();
    // This is a root, so we wrap it with the tree
    if (parentId === null) {
        return (React__default.createElement(FloatingTree, null,
            React__default.createElement(DropdownInner, { ...props })));
    }
    return React__default.createElement(DropdownInner, { ...props });
};

export { Dropdown };
